import React from "react"
import PropTypes from "prop-types"
import ItemNameValueShape from "../../state/shapes/ItemNameValueShape"
import Widget from "../layout/widget/Widget"
import GaugeComparisonChart from "../charts/generic/GaugeComparisonChart"

function CoffeeChatsCompleted({
  exportEndpoint, appliedFilters, data, subtitleKey,
}) {
  const titleKey="Widgets.CoffeeChatsCompleted.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      helpKey="Widgets.CoffeeChatCompletion.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
    >
      <GaugeComparisonChart formatDate={false} data={data} reverseLegend  titleKey={titleKey} subtitleKey={subtitleKey}/>
    </Widget>
  )
}

CoffeeChatsCompleted.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameValueShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
}

export default CoffeeChatsCompleted



// WEBPACK FOOTER //
// ./src/components/widgets/CoffeeChatsCompleted.jsx